import { useEffect, useState } from "react";

import { createPortal } from "react-dom";

import { useIsTablet } from "@musicfy/utils/hooks";

import NoticeBanner from "./NoticeBanner";

interface ISidebarProps {
  children?: React.ReactNode;
  id: string;
}

const Sidebar = ({ children, id }: ISidebarProps): JSX.Element | null => {
  const isTablet = useIsTablet();
  const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalTarget(
      document.getElementById("sidebar-container") || document.body
    );
  }, []);

  // SSR + first client paint: render nothing (matches empty sidebar container).
  if (isTablet || !portalTarget) {
    return null;
  }

  return createPortal(
    <div className="w-96 p-6">
      <div className="mt-16">
        <NoticeBanner />
      </div>
      {children}
    </div>,
    portalTarget,
    id
  );
};

export default Sidebar;
